<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-form
          ref="form"
        >
          <div class="subTitle">
            您的付款方式
          </div>
          <div>
            <v-radio-group
              v-model="bankType"
              :rules="[$store.state.validationRules.required]"
              row
              hide-details
              class="mb-2"
            >
              <v-radio
                label="銀行"
                value="bank"
              />
              <v-radio
                label="郵局"
                value="post"
              />
              <v-radio
                label="信用合作社"
                value="credit_cooperative"
              />
              <v-radio
                label="農會"
                value="peasant_association"
              />
              <v-radio
                label="漁會"
                value="fisherman_association"
              />
              <v-radio
                label="台灣Pay"
                value="twpay"
              />
            </v-radio-group>
            <v-select
              v-model="model.baBank"
              :items="bankItems"
              :rules="[$store.state.validationRules.required]"
              label="銀行"
              style="width: 200px;"
            />
          </div>
          <div class="subTitle mt-4">
            銀行帳號未6碼
          </div>
          <v-layout
            align-center
            class="mt-4"
          >
            <div style="letter-spacing: 0.4em;">
              ********
            </div>
            <v-flex
              xs4
              class="mx-2"
            >
              <InputNumLattice
                v-model="model.baAcctNo"
                :len="6"
                small
              />
            </v-flex>
          </v-layout>
          <div class="subTitle mt-4">
            匯款金額
          </div>
          <v-layout
            align-center
          >
            <v-flex
              xs2
              class="mr-2"
            >
              <v-text-field
                v-model="model.amout"
                :rules="[$store.state.validationRules.required]"
                type="number"
              />
            </v-flex>
            元
          </v-layout>
          <div class="subTitle mt-4">
            匯款時間
          </div>
          <div>
            <DatePicker
              v-model="model.payTime"
              style="width: 250px"
              type="datetime"
              confirm
              format="YYYY/MM/DD HH:mm"
            >
              <template #input>
                <v-text-field
                  :value="model.payTime | dateFormat('YYYY/MM/DD HH:mm')"
                  :rules="[$store.state.validationRules.required]"
                  placeholder="匯款時間"
                  readonly
                />
              </template>
            </DatePicker>
          </div>
          <v-btn
            :loading="submitLoading"
            :disabled="model.baAcctNo.length!==6"
            block
            color="info"
            class="mt-4"
            @click="submit"
          >
            <span
              style="font-size: 1.2em;"
            >
              送出
            </span>
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { getBankOptionItems } from '@g/data/bankList'
import InputNumLattice from '@/components/InputNumLattice'
import dayjs from 'dayjs'

export default {
  components: {
    InputNumLattice,
  },
  props: {
    type: {
      type: String,
      default: '儲值',
    }
  },
  data () {
    return {
      submitLoading: false,

      bankType: this.$route.query.bankType || '',
      model: {
        baAcctNo: '',
        baBank: '',
        baBranch: '',

        amout: '',
        payTime: new Date(dayjs().add(-30, 'minute')),
      },
      showTimeDialog: false,
    }
  },
  computed: {
    bankItems () {
      if (this.bankType) {
        return getBankOptionItems(this.bankType)
      }
      return []
    },
  },
  methods: {
    async submit () {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        this.submitLoading = true

        const model = this.model

        if (!model.baAcctNo) {
          this.$snackbar('請輸入銀行帳號未6碼')
          return
        }

        const bank = this.bankItems.find(item => item.value === this.model.baBank)

        const params = {
          // tag: 'after_sale',
          ignoreLimit: '1',
          title: '儲值沒到帳',
          content: `${this.type}沒到帳，${bank.text} ${model.baAcctNo}，${dayjs(model.payTime).format('YYYY/MM/DD HH:mm')} 付款 ${model.amout} 元。`,
          upyunFiles: [],
        }

        const res = await this.$store.dispatch('comment/createWorkOrder', params)
        if (!res.data.error) {
          this.cid = res.data.model.cid
          this.model.content = ''
          this.model.upyunFiles = []
          this.$emit('created', { cid: this.cid })
        }
      } finally {
        this.submitLoading = false
      }
    },
  }
}
</script>
